import { isValidDate, logRocketIdentifyUser, yyyymmdd } from "./Common";
import { logout } from "./ConnectionMiddleware";
import { checkConnected, callHub } from "./Connection";
import {
  addAvailableStatusToStore,
  addCanMessageTeams,
  addCanMessageUsers,
  addFeedThreads,
  initialiseHubConversionsInStore,
  initialiseTeamConversionSortMetricsInStore,
  initialiseOrganisationConversionsInStore,
  addLoggedInUserIdToStore,
  addMessagesToFeedThreadInStore,
  addMessagesToThreadInStore,
  addMessageThreadsToStore,
  addSelectedTeamToStore,
  addSnackbarIssue,
  addTeamsToStore,
  addUserContactsToStore,
  addTickerMessagesToStore,
  addConversionMetricsToStore,
  initialiseUserConversionsInStore,
  addUsersAvailabilityToStore,
  addUsersStatusToStore,
  addUsersToStore,
  updateMessageThreadInStore,
  updateStorageUrl,
  initialiseBuzzBucksBalancesInStore,
  initialiseBuzzBucksCurrentMainPoolInStore,
  initialiseBuzzBucksDistributorPoolInStore,
  initialiseBuzzBucksUserHistoryInStore,
  initialiseHrLeaveHolidaysInStore,
  addHrLeaveHolidayInStore,
  updateHrLeaveHolidayInStore,
  removeHrLeaveHolidayInStore,
  initialiseHrLeaveSicknessesInStore,
  addHrLeaveSicknessInStore,
  updateHrLeaveSicknessInStore,
  removeHrLeaveSicknessInStore,
  initialiseHrLeaveOthersInStore,
  addHrLeaveOtherInStore,
  updateHrLeaveOtherInStore,
  removeHrLeaveOtherInStore,
  initialiseHrLeavePublicHolidaysInStore,
  addHrLeavePublicHolidayInStore,
  updateHrLeavePublicHolidayInStore,
  removeHrLeavePublicHolidayInStore,
} from "./StoreCommon";
import ApiService from "../../services/ApiService";
import TokenHelper from "../../helpers/TokenHelper";
import PermissionService from "../../services/PermissionService";

export function apiGetUserView(userToLogin, setUserToLogin, setLoading) {
  const apiService = new ApiService();
  const permissionService = new PermissionService();
  
  apiService
    .getApiResponse("/boom/userView", "GET")
    .then((res) => {
      // returns a message with a UserView array.
      const userView = JSON.parse(res);

      console.log(userView);

      // add the logged in user id and settings to the store.
      addLoggedInUserIdToStore(userView["LoggedInUserId"], userView["ShowOrganisationTotals"]);

      // add users to the store.
      // add user status to store.
      addUsersToStore(userView["Users"]);
      addUsersStatusToStore(userView["Users"]);

      addUsersAvailabilityToStore(userView["Users"]);

      // add teams to store
      addTeamsToStore(userView["UserTeams"]);

      // add contacts to store
      addUserContactsToStore(userView["Contacts"]);

      // add statuses to statuses store
      addAvailableStatusToStore(userView["Statuses"]);

      // add selectedTeam to store
      addSelectedTeamToStore(userView["DefaultTeamId"]);

      // add teams to can message teams
      addCanMessageTeams(userView["UserTeams"]);

      // add can message users
      addCanMessageUsers(userView["Users"], userView["LoggedInUserId"]);

      // add settings
      updateStorageUrl(userView["StorageUrl"]);

      // add permissions/settings
      permissionService.setAutoRefreshFeed(userView.AutoRefreshFeed);
      permissionService.setCanAddFeedTickerMessage(userView.CanAddFeedTickerMessage);
      permissionService.setMuteNotifications(userView.MuteNotifications);
      permissionService.setPlayConversionSound(userView.PlayConversionSoundFl);
      permissionService.setBbPoolManagerFl(userView.BbPoolManagerFl);
      permissionService.setBbDistributorFl(userView.BbDistributorFl);
      permissionService.setEnableBuzzBucks(userView.EnableBuzzBucks);
      permissionService.setEnableHrLeave(userView.EnableHrLeave);
      permissionService.setHrAdminFl(userView.HrAdminFl);

      apiGetDmThreads().catch(() => {
        addSnackbarIssue("Unable to display the Message Centre", "warning");
      });

      apiGetFeedThreads().catch(() => {
        addSnackbarIssue("Unable to display the Feed", "warning");
      });

      getTickerMessages().catch(() => {
        addSnackbarIssue("Unable to display Breaking News", "warning");
      });

      getConversionMetrics().catch(() => {
        addSnackbarIssue("Unable to retrieve conversion metrics", "warning");
      });

      getUserConversionData().catch((error) => {
        addSnackbarIssue("Unable to display user conversion data", "warning");
      });

      getHubConversionData().catch(() => {
        addSnackbarIssue("Unable to display hub conversion data", "warning");
      });

      getOrganisationConversionData().catch(() => {
        addSnackbarIssue("Unable to display organisation conversion data", "warning");
      });

      getBuzzBucksCurrentBalances().catch(() => {
        addSnackbarIssue("Unable to display BuzzBucks data", "warning");
      });

      getBuzzBucksUserHistory().catch(() => {
        addSnackbarIssue("Unable to display BuzzBucks user history", "warning");
      });

      // Get main pool data if user is a Pool Manager
      if (permissionService.bbPoolManagerFl()) {
        getBuzzBucksCurrentMainPool().catch(() => {
          addSnackbarIssue("Unable to display BuzzBucks main pool data", "warning");
        });
      }

      // Get distributor pool data if user is a Distributor
      if (permissionService.bbDistributorFl()) {
        getBuzzBucksDistributorPool().catch(() => {
          addSnackbarIssue("Unable to display BuzzBucks distributor pool data", "warning");
        });
      }

      // identify the user in logrocket
      logRocketIdentifyUser(userView["Users"][0]);

      // Always check we are connected when getting the user view
      checkConnected().then(() => {
        if (userToLogin) {
          callHub("CheckUserIsLoggedIn")
            .then(() => {
              setUserToLogin(false);
              if (setLoading) setLoading(false);
            })
            .catch(() => {
              const tokenHelper = new TokenHelper();
              tokenHelper.removeAuthTokens();
              window.location.href = "/login";
            });
        } else if (setLoading) {
          setLoading(false);
        }
      });
    })
    .catch((err) => {
      //TODO: This snackbar is not going to be displayed. We need a way to store messages so they can be displayed on
      // login screen or show an alert for a serious message and then return the user to the login screen
      addSnackbarIssue(
        "Unable to retreive your user view. Please try logging in again",
        "warning"
      );
      logout();
    });
}

export async function apiGetFeedThreads() {
  const apiService = new ApiService();
  return apiService
    .getApiResponse("/thread/feedthreads", "GET")
    .then((threadList) => {
      addFeedThreads(threadList);
    });
}

export async function apiGetFeedThreadMessages(threadId) {
  const apiService = new ApiService();

  return apiService
    .getApiResponse(
      `/thread/openthread/${threadId}?maxMessages=2147483647`,
      "GET"
    )
    .then((messageArray) => {
      addMessagesToFeedThreadInStore(messageArray.Messages);
    });
}

export async function apiGetDmThreads() {
  const apiService = new ApiService();
  return apiService
    .getApiResponse("/thread/directmessagethreads", "GET")
    .then((threadList) => {
      addMessageThreadsToStore(threadList);
    });
}

export async function apiGetDmThreadMessages(threadId) {
  const apiService = new ApiService();

  return apiService
    .getApiResponse(`/thread/openthread/${threadId}?maxMessages=20`, "GET")
    .then((messageArray) => {
      updateMessageThreadInStore({
        Id: messageArray.ThreadId,
        EarlierMessagesExist: messageArray.EarlierMessagesExist,
      });
      addMessagesToThreadInStore(messageArray.Messages);
    });
}

export async function apiGetEarlierDmThreadMessages(threadId, utcBefore) {
  const apiService = new ApiService();

  return apiService.getApiResponse(
      `/thread/threadmessagesbefore/${threadId}?utcBefore=${utcBefore}&maxMessages=20`,
      "GET"
    )
    .then((threadArray) => {
      updateMessageThreadInStore({
        Id: threadArray.ThreadId,
        EarlierMessagesExist: threadArray.EarlierMessagesExist,
      });
      addMessagesToThreadInStore(threadArray.Messages);
    });
}

export async function apiMarkDmThreadAsDisplayed(threadId) {
  const apiService = new ApiService();

  return apiService.getApiResponse(
      `/thread/markthreadasdisplayed/${threadId}`,
      "POST"
    );
}

export function apiGetEarlierFeedThreads(oldestStoredFeedDate) {
  let date = new Date();
  if (isValidDate(oldestStoredFeedDate)) date = new Date(oldestStoredFeedDate);

  const apiService = new ApiService();

  return apiService
    .getApiResponse(
      `/thread/feedthreadsbefore?utcBefore=${date.toISOString()}`,
      "GET"
    )
    .then((threadArray) => {
      addFeedThreads(threadArray);
    })
    .catch((err) => {
      addSnackbarIssue(
        "Loading earlier posts failed, please try again!",
        "warning"
      );
    });
}

/** Shared with stats UI so failed/invalid responses show the same snackbar as HTTP errors. */
export const USER_ACTIVITY_REPORT_FAILED_MESSAGE =
  "Retrieving reports failed, please try again!";

export async function getUserActivityReport(userId, fromDate, toDate) {
  if (!userId) return;
  if (!fromDate) {
    fromDate = yyyymmdd();
  }
  let url = `/report/dailyactivity?userId=${userId}&&date=${fromDate}`;
  if (toDate && toDate !== fromDate) {
    // if the user selects a date range then get the range activity
    url = `/report/dailyactivityrange?userId=${userId}&&fromdate=${fromDate}&&todate=${toDate}`;
  }

  const apiService = new ApiService();

  return apiService.getApiResponse(url, "GET").catch((err) => {
    addSnackbarIssue(USER_ACTIVITY_REPORT_FAILED_MESSAGE, "warning");
    throw err;
  });
}

export async function getTickerMessages() {
  const apiService = new ApiService();
  return apiService
    .getApiResponse("/ticker/getmessages", "GET")
    .then((json) => {
      addTickerMessagesToStore(json);
    });
}

export async function getConversionMetrics() {
  const apiService = new ApiService();
  return apiService
    .getApiResponse("/conversion/getmetrics", "GET")
    .then((json) => {
      addConversionMetricsToStore(json);
    });
}

export async function getUserConversionData() {
  const apiService = new ApiService();
  return apiService
    .getApiResponse("/conversion/getuserdata", "GET")
    .then((json) => {
      initialiseUserConversionsInStore(json);
    });
}

export async function getHubConversionData() {
  const apiService = new ApiService();
  return apiService
    .getApiResponse("/conversion/gethubdata", "GET")
    .then((json) => {
      initialiseHubConversionsInStore(json);
      return apiService.getApiResponse(
        "/conversion/getteamconversionmetricssortedby",
        "GET"
      );
    })
    .then((sortJson) => {
      initialiseTeamConversionSortMetricsInStore(sortJson);
    });
}

export async function getOrganisationConversionData() {
  const apiService = new ApiService();
  return apiService
    .getApiResponse("/conversion/getorganisationdata", "GET")
    .then((json) => {
      initialiseOrganisationConversionsInStore(json);
    });
}

export async function getConversionOverview(userId, dateTimePeriod, conversionMetricId) {
  const apiService = new ApiService();
  const params = new URLSearchParams({
    userId,
    dateTimePeriod,
    conversionMetricId: String(conversionMetricId),
  });
  return apiService
    .getApiResponse(`/conversion/getconversionoverview?${params.toString()}`, "GET");
}

export async function getBuzzBucksCurrentBalances() {
  const apiService = new ApiService();
  return apiService
    .getApiResponse("/buzzbucks/getusercurrentbalances", "GET")
    .then((json) => {
      initialiseBuzzBucksBalancesInStore(json);
    });
}

export async function getBuzzBucksUserHistory() {
  const apiService = new ApiService();
  return apiService
    .getApiResponse("/buzzbucks/getuserhistory", "GET")
    .then((json) => {
      initialiseBuzzBucksUserHistoryInStore(json);
    });
}

export async function getBuzzBucksCurrentMainPool() {
  const apiService = new ApiService();
  return apiService
    .getApiResponse("/buzzbucks/getcurrentmainpool", "GET")
    .then((json) => {
      initialiseBuzzBucksCurrentMainPoolInStore(json);
    });
}

export async function getBuzzBucksDistributorPool() {
  const apiService = new ApiService();
  return apiService
    .getApiResponse("/buzzbucks/getdistributorpool", "GET")
    .then((json) => {
      initialiseBuzzBucksDistributorPoolInStore(json);
    });
}

export async function getHrLeaveHolidays(fromDateTime, toDateTime) {
  const apiService = new ApiService();
  const params = new URLSearchParams({
    fromDateTime,
    toDateTime,
  });
  return apiService
    .getApiResponse(`/hrleave/getholidays?${params.toString()}`, "GET")
    .then((json) => {
      initialiseHrLeaveHolidaysInStore(json);
      return json;
    });
}

export async function apiAddHoliday({
  appUserId,
  startDateTime,
  endDateTime,
  durationType,
  partDayType,
  comments,
}) {
  const apiService = new ApiService();
  const params = new URLSearchParams({
    appUserId: String(appUserId),
    startDateTime,
    endDateTime,
    durationType,
  });
  if (partDayType) params.append("partDayType", partDayType);
  if (comments) params.append("comments", comments);

  return apiService
    .getApiResponse(`/hrleave/addholiday?${params.toString()}`, "POST")
    .then((json) => {
      addHrLeaveHolidayInStore(json);
      return json;
    });
}

export async function apiRequestHoliday({
  startDateTime,
  endDateTime,
  durationType,
  partDayType,
  comments,
}) {
  const apiService = new ApiService();
  const params = new URLSearchParams({
    startDateTime,
    endDateTime,
    durationType: durationType || "WholeDay",
  });
  if (partDayType) params.append("partDayType", partDayType);
  if (comments) params.append("comments", comments);

  return apiService
    .getApiResponse(`/hrleave/requestholiday?${params.toString()}`, "POST")
    .then((json) => {
      addHrLeaveHolidayInStore(json);
      return json;
    });
}

export async function apiActionHoliday({ holidayId, status, comments }) {
  const apiService = new ApiService();
  const params = new URLSearchParams({
    holidayId: String(holidayId),
    status,
  });
  if (comments) params.append("comments", comments);

  return apiService
    .getApiResponse(`/hrleave/actionholiday?${params.toString()}`, "POST")
    .then((json) => {
      updateHrLeaveHolidayInStore(json);
      return json;
    });
}

export async function apiUpdateHoliday({
  holidayId,
  appUserId,
  startDateTime,
  endDateTime,
  durationType,
  partDayType,
  comments,
}) {
  const apiService = new ApiService();
  const params = new URLSearchParams({
    holidayId: String(holidayId),
    appUserId: String(appUserId),
    startDateTime,
    endDateTime,
    durationType,
  });
  if (partDayType) params.append("partDayType", partDayType);
  if (comments) params.append("comments", comments);

  return apiService
    .getApiResponse(`/hrleave/updateholiday?${params.toString()}`, "POST")
    .then((json) => {
      updateHrLeaveHolidayInStore(json);
      return json;
    });
}

export async function apiDeleteHoliday(holidayId) {
  const apiService = new ApiService();
  const params = new URLSearchParams({ holidayId: String(holidayId) });
  return apiService
    .getApiResponse(`/hrleave/deleteholiday?${params.toString()}`, "POST")
    .then(() => {
      removeHrLeaveHolidayInStore(holidayId);
    });
}

export async function apiImportHolidays(file) {
  const formData = new FormData();
  formData.append("file", file);
  const tokenHelper = new TokenHelper();
  const apiUrl = process.env.REACT_APP_API;
  const response = await fetch(`${apiUrl}/hrleave/importholidays`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + tokenHelper.getAccessToken(),
    },
    body: formData,
  });
  if (!response.ok) {
    throw new Error("Import failed");
  }
  return response.json();
}

export async function getHrLeaveSicknesses(fromDateTime, toDateTime) {
  const apiService = new ApiService();
  const params = new URLSearchParams({
    fromDateTime,
    toDateTime,
  });
  return apiService
    .getApiResponse(`/hrleave/getsicknesses?${params.toString()}`, "GET")
    .then((json) => {
      initialiseHrLeaveSicknessesInStore(json);
      return json;
    });
}

export async function apiAddSickness({ appUserId, startDateTime, endDateTime }) {
  const apiService = new ApiService();
  const params = new URLSearchParams({
    appUserId: String(appUserId),
    startDateTime,
    endDateTime,
  });

  return apiService
    .getApiResponse(`/hrleave/addsickness?${params.toString()}`, "POST")
    .then((json) => {
      addHrLeaveSicknessInStore(json);
      return json;
    });
}

export async function apiUpdateSickness({
  sicknessId,
  appUserId,
  startDateTime,
  endDateTime,
}) {
  const apiService = new ApiService();
  const params = new URLSearchParams({
    sicknessId: String(sicknessId),
    appUserId: String(appUserId),
    startDateTime,
    endDateTime,
  });

  return apiService
    .getApiResponse(`/hrleave/updatesickness?${params.toString()}`, "POST")
    .then((json) => {
      updateHrLeaveSicknessInStore(json);
      return json;
    });
}

export async function apiDeleteSickness(sicknessId) {
  const apiService = new ApiService();
  const params = new URLSearchParams({ sicknessId: String(sicknessId) });
  return apiService
    .getApiResponse(`/hrleave/deletesickness?${params.toString()}`, "POST")
    .then(() => {
      removeHrLeaveSicknessInStore(sicknessId);
    });
}

export async function apiImportSicknesses(file) {
  const formData = new FormData();
  formData.append("file", file);
  const tokenHelper = new TokenHelper();
  const apiUrl = process.env.REACT_APP_API;
  const response = await fetch(`${apiUrl}/hrleave/importsicknesses`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + tokenHelper.getAccessToken(),
    },
    body: formData,
  });
  if (!response.ok) {
    throw new Error("Import failed");
  }
  return response.json();
}

export async function getHrLeaveOthers(fromDateTime, toDateTime) {
  const apiService = new ApiService();
  const params = new URLSearchParams({
    fromDateTime,
    toDateTime,
  });
  return apiService
    .getApiResponse(`/hrleave/getothers?${params.toString()}`, "GET")
    .then((json) => {
      initialiseHrLeaveOthersInStore(json);
      return json;
    });
}

export async function apiAddOther({
  appUserId,
  startDateTime,
  endDateTime,
  eventType,
  durationMins,
  comments,
}) {
  const apiService = new ApiService();
  const params = new URLSearchParams({
    appUserId: String(appUserId),
    startDateTime,
    endDateTime,
    eventType,
    durationMins: String(durationMins),
  });
  if (comments) params.append("comments", comments);

  return apiService
    .getApiResponse(`/hrleave/addother?${params.toString()}`, "POST")
    .then((json) => {
      addHrLeaveOtherInStore(json);
      return json;
    });
}

export async function apiUpdateOther({
  otherId,
  appUserId,
  startDateTime,
  endDateTime,
  eventType,
  durationMins,
  comments,
}) {
  const apiService = new ApiService();
  const params = new URLSearchParams({
    otherId: String(otherId),
    appUserId: String(appUserId),
    startDateTime,
    endDateTime,
    eventType,
    durationMins: String(durationMins),
  });
  if (comments) params.append("comments", comments);

  return apiService
    .getApiResponse(`/hrleave/updateother?${params.toString()}`, "POST")
    .then((json) => {
      updateHrLeaveOtherInStore(json);
      return json;
    });
}

export async function apiDeleteOther(otherId) {
  const apiService = new ApiService();
  const params = new URLSearchParams({ otherId: String(otherId) });
  return apiService
    .getApiResponse(`/hrleave/deleteother?${params.toString()}`, "POST")
    .then(() => {
      removeHrLeaveOtherInStore(otherId);
    });
}

export async function apiImportOthers(file) {
  const formData = new FormData();
  formData.append("file", file);
  const tokenHelper = new TokenHelper();
  const apiUrl = process.env.REACT_APP_API;
  const response = await fetch(`${apiUrl}/hrleave/importothers`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + tokenHelper.getAccessToken(),
    },
    body: formData,
  });
  if (!response.ok) {
    throw new Error("Import failed");
  }
  return response.json();
}

export async function getHrLeavePublicHolidays(fromDateTime, toDateTime) {
  const apiService = new ApiService();
  const params = new URLSearchParams({
    fromDateTime,
    toDateTime,
  });
  return apiService
    .getApiResponse(`/hrleave/getpublicholidays?${params.toString()}`, "GET")
    .then((json) => {
      initialiseHrLeavePublicHolidaysInStore(json);
      return json;
    });
}

export async function apiAddPublicHoliday({ title, startDateTime, endDateTime }) {
  const apiService = new ApiService();
  const params = new URLSearchParams({
    title,
    startDateTime,
    endDateTime,
  });

  return apiService
    .getApiResponse(`/hrleave/addpublicholiday?${params.toString()}`, "POST")
    .then((json) => {
      addHrLeavePublicHolidayInStore(json);
      return json;
    });
}

export async function apiUpdatePublicHoliday({
  publicHolidayId,
  title,
  startDateTime,
  endDateTime,
}) {
  const apiService = new ApiService();
  const params = new URLSearchParams({
    publicHolidayId: String(publicHolidayId),
    title,
    startDateTime,
    endDateTime,
  });

  return apiService
    .getApiResponse(`/hrleave/updatepublicholiday?${params.toString()}`, "POST")
    .then((json) => {
      updateHrLeavePublicHolidayInStore(json);
      return json;
    });
}

export async function apiDeletePublicHoliday(publicHolidayId) {
  const apiService = new ApiService();
  const params = new URLSearchParams({
    publicHolidayId: String(publicHolidayId),
  });
  return apiService
    .getApiResponse(`/hrleave/deletepublicholiday?${params.toString()}`, "POST")
    .then(() => {
      removeHrLeavePublicHolidayInStore(publicHolidayId);
    });
}

export async function getHrLeaveAccess() {
  const apiService = new ApiService();
  return apiService.getApiResponse(`/hrleave/getaccess`, "GET");
}

export async function apiSetHrLeaveAccess(userNames) {
  const apiService = new ApiService();
  const params = new URLSearchParams({
    userNames: userNames || "",
  });
  return apiService.getApiResponse(
    `/hrleave/setaccess?${params.toString()}`,
    "POST"
  );
}

export async function getLoggedInUserProfile() {
  const apiService = new ApiService();
  return await apiService
    .getApiResponse(`/useradmin/user`, "GET")
    .then((res) => {
      return res;
    })
    .catch((err) => {
      addSnackbarIssue(
        "Error loading user profile. Please try again",
        "warning"
      );
      return { error: true };
    });
}

export async function apiGetAchievementText(id) {
  const apiService = new ApiService();
  return apiService
    .getApiResponse(`/conversion/getachievementtext?achievementId=${id}`, "GET")
    .then((text) => {
      return text;
    });
}

export async function getUserProfile(userId) {
  const apiService = new ApiService();
  return await apiService
    .getApiResponse(`/admin/user/${userId}`, "GET")
    .then((res) => {
      return res;
    })
    .catch((err) => {
      addSnackbarIssue(
        "Error loading user profile. Please try again",
        "warning"
      );
      return { error: true };
    });
}

export async function updateUserProfile(user) {
  const apiService = new ApiService();
  return await apiService.getApiResponse(`/admin/user`, "POST", user);
}

export async function updateSimpleUserProfile(user) {
  const apiService = new ApiService();
  return await apiService.getApiResponse(`/admin/simpleuser`, "POST", user);
}

export async function updateCurrentUserProfile(user) {
  const apiService = new ApiService();

  return await apiService.getApiResponse(`/useradmin/user`, "POST", user);
    
}
